//import 'bootstrap';
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/modal';
